import React from "react";
import SyncLoader from "react-spinners/SyncLoader";
import '../css/modalCarga.css';

class ModalCarga extends React.Component {
  render() {
    const { show } = this.props;

    if (!show) return null;

    return (
      <>
        <div className="glass-overlay">
          <div className="text-center">
                <SyncLoader size={40} color="#3EBC70" margin={15} speedMultiplier={0.8}/>
          </div>
        </div>
      </>
    );
  }
}

export default ModalCarga;